import parsePhoneNumberFromString from "libphonenumber-js";

export const ADMIN_JOINED_FROM = {
  SUPER_ADMIN: "SuperAdmin",
  WEBSITE_SIGNUP: "Website",
  ALL: "All",
};

export const DEFAULT_PRICING_PLAN = {
  baseCharge: 75,
  companyUser: 44,
  readWrite: 44,
  topo: 44,
  readOnly: 10,
  currency: 'usd',
  foundationAnalysisAddOn: 0,
  floorLevelAddOn: 0
};

/**
 * Pay-As-You-Go defaults.
 *
 * NAMING TRAP: `DEFAULT_PRICING_PLAN.topo` above is the monthly price of one Topo-User
 * SEAT. It has nothing to do with `pricePerTopo` here, which is the price of creating one
 * topo. The two live in separate objects on purpose - keep it that way.
 */
export const DEFAULT_PAYG_PLAN = {
  baseCharge: 0,
  pricePerTopo: 25,
  currency: 'usd',
  invoiceDayOfMonth: 1
};

export const BILLING_MODE = {
  SEAT: 'SEAT',
  PAYG: 'PAYG'
};

export const BILLING_MODE_LABEL = {
  SEAT: 'Seat-based',
  PAYG: 'Pay As You Go'
};

export const PAYG_VALIDATION = {
  MIN_BASE_CHARGE: 0,
  MAX_BASE_CHARGE: 10000,
  MIN_PRICE_PER_TOPO: 0,
  MAX_PRICE_PER_TOPO: 5000,
  MIN_INVOICE_DAY: 1,
  MAX_INVOICE_DAY: 5
};

export const COMPANY_SUBSCRIPTION_STATUS = {
  pending: 'Pending',
  active: 'Active',
  canceled: 'Canceled',
  trialing: 'Trial',
  past_due: 'Past Due',
  unpaid: 'Unpaid',
  incomplete: 'Incomplete',
  incomplete_expired: 'Incomplete Expired'
}

export const formatDate = (dateString) => {
  if (!dateString) return "-";

  const date = new Date(dateString);
  return isNaN(date.getTime())
    ? "-"
    : date.toLocaleDateString("en-GB", {
      day: "numeric",
      month: "short",
      year: "numeric",
    });
}

export function formatPhoneNumber(countryCode, phoneNo) {
  if (!phoneNo || !countryCode) return '-';

  const fullNumber = `${countryCode}${phoneNo}`;

  try {
    const phoneNumber = parsePhoneNumberFromString(fullNumber);
    return phoneNumber ? phoneNumber.formatInternational() : `${countryCode} ${phoneNo}`;
  } catch (error) {
    console.log('INSIDE ELSE BLOCK <<', error);
    return `${countryCode} ${phoneNo}`;
  }
}

export const USER_TYPE_MAPPING = {
  0: "Read & Write",
  1: "Read Only",
  2: "Company Admin",
  3: "Topo"
};